export default __webpack_public_path__ + "static/media/chevron-down.3cfe8d56.svg";